import React from 'react'
import PropTypes from 'prop-types'
import Wrapper from './src/components/Wrapper'
import './global.css'

export const wrapPageElement = ({ element, props }) => {
  const theme = props.pageContext.customTheme
  return theme ? <Wrapper customTheme={theme}>{element}</Wrapper> : element
}

wrapPageElement.propTypes = {
  element: PropTypes.node.isRequired,
}
